module.exports = __webpack_public_path__ + "img/Home_Control-Deck-back.c96abc57.png";